import axios from 'axios';
import settings from '../config/settings';
import { API } from '../config/api';
import { AUTH_TOKEN, USER_DATA } from '../config/constants';
import { getByKey, updateByKey, deleteByKey } from '../storage/StorageEx';
import { IUserSession } from '../../swagger/shared/user';
import GlobalStore from '../stores/GlobalStore';

export const toBoolean = (v: any): boolean => (typeof v === 'string' && v.toLowerCase() === 'true') || +v === 1;

export const getAuthToken = () => {
  const t = getByKey<string>(AUTH_TOKEN);
  return t ? `SIEA ${t}` : '';
};

export const setAxiosDefaults = () => {
  axios.defaults.baseURL = settings.API_BASE_URL;
  axios.defaults.headers.common['Authorization'] = getAuthToken();
};

// Po úspešnom logine: ulož token + user, nastav axios hlavičku
export const persistLogin = (user: IUserSession) => {
  updateByKey(USER_DATA, user);
  if (user?.sieatoken) {
    updateByKey(AUTH_TOKEN, user.sieatoken);
    axios.defaults.headers.common['Authorization'] = `SIEA ${user.sieatoken}`;
  }
};

export const logout = async () => {
  GlobalStore.loading(true, 'Odhlasovanie...');
  try {
    await axios.post(API.logout()).catch(() => {});
  } finally {
    deleteByKey(USER_DATA);
    deleteByKey(AUTH_TOKEN);
    axios.defaults.headers.common['Authorization'] = '';
    GlobalStore.loading(false);
    window.location.assign('/login');
  }
};

export function stringToHashCode(str: string) {
  return str
    .split('')
    .reduce((prevHash, currVal) => ((prevHash << 5) - prevHash + currVal.charCodeAt(0)) | 0, 0)
    .toString();
}
